import EmbedHtml from '@/components/embeds/EmbedHtml/EmbedHtml'
import styles from '../Default/DPADefault.module.scss'

export type WidgetDpaContext = {
  readonly items?: ReadonlyArray<{
    readonly id: string
    readonly model: {
      readonly fields: {
        readonly html: string
      }
    }
  }>
}

export default function DpaInline({
  item,
}: Readonly<{
  item: WidgetDpaContext
}>) {
  return (
    <>
      {item.items?.map((embed) => (
        <div key={embed.id} className={styles.wrapper}>
          <EmbedHtml html={embed.model.fields.html} />
        </div>
      ))}
    </>
  )
}
